import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const TAG_INSTALL_INTEGRATION_NAME = 'tag-install';
export const ZTagInstallIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(TAG_INSTALL_INTEGRATION_NAME),
    category: z.literal('analytics'),
    credentials: z.object({}).optional(),
    settings: z.object({}).optional(),
}).shape);
//# sourceMappingURL=tag-install.js.map